import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axios from "../../../src/core/api/axiosClient";

const initialState: any = {
  assetTypes: [],
  assetTypeDetails: {},
  isLoading: false,
  error: null,

  allAssetTypes: [],
  isLoadingAllAssetType: false,
};

export const getAssetTypes: any = createAsyncThunk(
  "content/getAssetTypes",
  async ({ PageNumber, pageSize }: any) => {
    const res = await axios.get(`/slpapp/AssetType/getallParentAssetTypes`, {
      params: { PageNumber, pageSize },
    });
    const data = await res.data;
    return data;
  }
);

export const getAllAssetTypes: any = createAsyncThunk(
  "content/getAllAssetTypes",
  async () => {
    const res = await axios.get(`/slpapp/AssetType/getall`);

    const data = await res?.data;
    return data;
  }
);

export const assetTypeSlice = createSlice({
  name: "assetType",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(getAssetTypes.pending, (state) => {
      state.isLoading = true;
    });
    builder.addCase(getAssetTypes.fulfilled, (state, action) => {
      state.isLoading = false;
      state.assetTypes = action.payload;
    });
    builder.addCase(getAssetTypes.rejected, (state, action) => {
      state.isLoading = false;
      state.error = action.error.message;
    });

    builder.addCase(getAllAssetTypes.pending, (state) => {
      state.isLoadingAllAssetType = true;
    });
    builder.addCase(getAllAssetTypes.fulfilled, (state, action) => {
      state.isLoadingAllAssetType = false;
      state.allAssetTypes = action.payload;
    });
    builder.addCase(getAllAssetTypes.rejected, (state, action) => {
      state.isLoadingAllAssetType = false;
      state.error = action.error.message;
    });
  },
});

export default assetTypeSlice.reducer;
